var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_124_2451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_124_2451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_home_2",
    d: "M10.0007 2.5L16.6673 7.5V17.5H3.33398V7.5L10.0007 2.5ZM10.0007 12.5C10.6951 12.5 11.2854 12.2569 11.7715 11.7708C12.2576 11.2847 12.5007 10.6944 12.5007 10C12.5007 9.30556 12.2576 8.71528 11.7715 8.22917C11.2854 7.74306 10.6951 7.5 10.0007 7.5C9.30621 7.5 8.71593 7.74306 8.22982 8.22917C7.74371 8.71528 7.50065 9.30556 7.50065 10C7.50065 10.6944 7.74371 11.2847 8.22982 11.7708C8.71593 12.2569 9.30621 12.5 10.0007 12.5ZM10.0007 10.8333C9.76454 10.8333 9.56662 10.7535 9.4069 10.5938C9.24718 10.434 9.16732 10.2361 9.16732 10C9.16732 9.76389 9.24718 9.56597 9.4069 9.40625C9.56662 9.24653 9.76454 9.16667 10.0007 9.16667C10.2368 9.16667 10.4347 9.24653 10.5944 9.40625C10.7541 9.56597 10.834 9.76389 10.834 10C10.834 10.2361 10.7541 10.434 10.5944 10.5938C10.4347 10.7535 10.2368 10.8333 10.0007 10.8333ZM10.0007 15C9.43121 15 8.87565 15.0694 8.33398 15.2083C7.79232 15.3472 7.27843 15.5556 6.79232 15.8333H13.209C12.7229 15.5556 12.209 15.3472 11.6673 15.2083C11.1257 15.0694 10.5701 15 10.0007 15ZM5.00065 8.33333V15C5.72287 14.4583 6.5076 14.0451 7.35482 13.7604C8.20204 13.4757 9.08398 13.3333 10.0007 13.3333C10.9173 13.3333 11.7993 13.4757 12.6465 13.7604C13.4937 14.0451 14.2784 14.4583 15.0007 15V8.33333L10.0007 4.58333L5.00065 8.33333Z",
    fill: "url(#paint0_linear_124_2451)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_124_2451",
    x1: 10.0007,
    y1: 2.5,
    x2: 10.0007,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/myProfile.6c0d7e1f269541f9e6d597b64582f87e.svg";
export { ForwardRef as ReactComponent };